<template>
  <v-dialog
    v-model="show"
    fullscreen
    hide-overlay
    transition="dialog-bottom-transition"
  >
    <v-card>
      <!-- <v-card-title class="body-1">
        {{ $vuetify.lang.t('$vuetify.EDIT_WHITELISTS.USERS') }} -
        {{ whitelist.Name }}
        <v-spacer></v-spacer>
        <v-btn icon small @click="show = false">
          <v-icon small>mdi-close</v-icon>
        </v-btn>
      </v-card-title> -->
      <v-toolbar dark color="secondary">
        <v-toolbar-title>
          <v-btn icon small @click="show = false">
            <v-icon small>mdi-chevron-left</v-icon>
          </v-btn>
          {{ $vuetify.lang.t('$vuetify.EDIT_WHITELISTS.USERS') }} -
          {{ whitelist.Name }}
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon small @click="show = false">
          <v-icon small>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <!-- <whitelist-form
          @valid="saveButtonDisabled = false"
          @invalid="saveButtonDisabled = true"
        /> -->
        <v-data-table
          :items="whitelist.Users ? whitelist.Users : []"
          :loading="
            loading.type === 'getWhitelist' ||
              loading.type === 'getWhitelistUsers'
          "
          :headers="[
            {
              text: $vuetify.lang.t('$vuetify.EDIT_WHITELISTS.PHONE_NUMBER'),
              align: 'start',
              sortable: false,
              value: 'PhoneNumber'
            },
            {
              text: $vuetify.lang.t('$vuetify.EDIT_WHITELISTS.CAR_NUMBERS'),
              sortable: false,
              value: 'Vehicles'
            },
            {
              text: $vuetify.lang.t('$vuetify.EDIT_WHITELISTS.NAME'),
              sortable: true,
              value: 'Name'
            },
            {
              text: $vuetify.lang.t('$vuetify.EDIT_WHITELISTS.EMAIL'),
              sortable: true,
              value: 'Email'
            },
            {
              text: $vuetify.lang.t('$vuetify.VALID_FROM'),
              sortable: true,
              value: 'ValidFrom'
            },
            {
              text: $vuetify.lang.t('$vuetify.VALID_TO'),
              align: 'center',
              sortable: false,
              value: 'ValidTo'
            },
            {
              text: $vuetify.lang.t('$vuetify.EDIT_WHITELISTS.REG_TYPE'),
              sortable: true,
              sortable: false,
              value: 'RegistrationType'
            },
            {
              text: $vuetify.lang.t('$vuetify.EDIT_WHITELISTS.COMMENTS'),
              sortable: true,
              sortable: false,
              value: 'Comments'
            },
            {
              text: $vuetify.lang.t('$vuetify.EDIT_WHITELISTS.REG_TIME'),
              sortable: true,
              value: 'CreatedAt'
            },
            {
              text: $vuetify.lang.t('$vuetify.EDIT_WHITELISTS.STATUS'),
              value: 'Status'
            },
            { text: '', sortable: false, value: 'actions' }
          ]"
          hide-default-footer
          :items-per-page="-1"
        >
          <template v-slot:top>
            <v-toolbar flat class="mt-4">
              <v-spacer></v-spacer>
              <vue-xlsx-table @on-select-file="onFileSelect">
                <v-btn small text color="dark">
                  <v-icon class="mr-2">mdi-file-import</v-icon>
                  {{ $vuetify.lang.t('$vuetify.IMPORT_FROM_FILE') }}
                </v-btn>
              </vue-xlsx-table>
              <v-menu offset-y dense>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn icon small v-bind="attrs" v-on="on">
                    <v-icon>mdi-dots-horizontal</v-icon>
                  </v-btn>
                </template>
                <v-list dense>
                  <v-list-item @click="downloadTemplateFile()">
                    <v-list-item-title>
                      <v-icon small class="mr-2">mdi-download</v-icon>
                      {{ $vuetify.lang.t('$vuetify.DOWNLOAD_TEMPLATE_FILE') }}
                    </v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
              <v-btn
                color="success"
                text
                small
                @click="openEditWhitelistUserDialog()"
              >
                <v-icon class="mr-2">mdi-plus</v-icon>
                {{ $vuetify.lang.t('$vuetify.WHITELISTS.ADD_NEW') }}
              </v-btn>
            </v-toolbar>
          </template>
          <template v-slot:item.PhoneNumber="props">
            <td>
              {{ props.item.PhoneNumber ? props.item.PhoneNumber : '-' }}
            </td>
          </template>
          <template v-slot:item.Name="props">
            <td>
              {{ props.item.Name ? props.item.Name : '-' }}
            </td>
          </template>
          <template v-slot:item.Vehicles="props">
            <td>
              {{
                props.item.Vehicles && props.item.Vehicles.length
                  ? Object.keys(props.item.Vehicles)
                      .map(function(i) {
                        return props.item.Vehicles[i].PlateNumber
                      })
                      .join(';')
                  : '-'
              }}
            </td>
          </template>
          <template v-slot:item.Email="props">
            <td>
              {{ props.item.Email ? props.item.Email : '-' }}
            </td>
          </template>
          <template v-slot:item.ValidFrom="props">
            <td>
              {{
                props.item.ValidFrom
                  ? dateEE(props.item.ValidFrom, '.', false)
                  : '-'
              }}
            </td>
          </template>
          <template v-slot:item.ValidTo="props">
            <td class="d-flex justify-center">
              {{
                props.item.ValidTo && props.item.ValidTo !== ''
                  ? dateEE(props.item.ValidTo, '.', false)
                  : '&infin;'
              }}
            </td>
          </template>
          <template v-slot:item.CreatedAt="props">
            <td>{{ dateEE(props.item.CreatedAt, '.') }}</td>
          </template>
          <template v-slot:item.Status="props">
            <td>
              <span
                v-if="props.item.Status === 'APPROVED'"
                class="success--text"
              >
                {{ props.item.Status }}
              </span>
              <span v-else>{{ props.item.Status }}</span>
              <div
                v-if="props.item.Status == '' || props.item.Status == 'PENDING'"
              >
                <v-btn
                  color="success"
                  outlined
                  small
                  class="mr-1"
                  @click="updateUserStatus(props.item, 'APPROVED')"
                >
                  Approve
                </v-btn>
                <v-btn
                  v-show="props.item.RegistrationType !== 'MANUALLY_ADDED'"
                  color="error"
                  outlined
                  small
                  @click="updateUserStatus(props.item, 'DECLINED')"
                >
                  Decline
                </v-btn>
              </div>
            </td>
          </template>
          <template v-slot:item.actions="{ item }">
            <td>
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-btn
                    icon
                    color="primary"
                    small
                    outlined
                    class="mr-3"
                    @click="openEditWhitelistUserDialog(item)"
                    v-on="on"
                  >
                    <v-icon small>mdi-pencil</v-icon>
                  </v-btn>
                </template>
                <span>
                  {{ $vuetify.lang.t('$vuetify.EDIT') }}
                </span>
              </v-tooltip>

              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-btn
                    icon
                    color="error"
                    small
                    outlined
                    @click="deleteUser(item)"
                    v-on="on"
                  >
                    <v-icon small>mdi-delete</v-icon>
                  </v-btn>
                </template>
                <span>
                  {{ $vuetify.lang.t('$vuetify.DELETE') }}
                </span>
              </v-tooltip>
            </td>
          </template>
          <template v-slot:item.RegistrationType="{ item }">
            <td>
              {{ registrationTypeText(item) }}
            </td>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
    <edit-whitelist-user-dialog
      v-if="selectedUser"
      :selected-user="selectedUser"
      :visible="editWhitelistUserDialog"
      @close="
        editWhitelistUserDialog = false
        selectedUser = null
      "
    />
    <v-dialog v-model="userImportConfirmDialog" width="700">
      <v-card>
        <v-card-title class="headline lighten-2" primary-title>
          {{ $vuetify.lang.t('$vuetify.PREVIEW') }}
          <v-spacer></v-spacer>
          <v-btn icon small @click="userImportConfirmDialog = false">
            <v-icon small>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text>
          <v-simple-table>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left">
                    {{
                      $vuetify.lang.t('$vuetify.EDIT_WHITELISTS.PHONE_NUMBER')
                    }}
                  </th>
                  <th class="text-left">
                    {{ $vuetify.lang.t('$vuetify.EDIT_WHITELISTS.CAR_NUMBER') }}
                  </th>
                  <th class="text-left">
                    {{ $vuetify.lang.t('$vuetify.EDIT_WHITELISTS.NAME') }}
                  </th>
                  <th class="text-left">
                    {{ $vuetify.lang.t('$vuetify.EDIT_WHITELISTS.EMAIL') }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in arrayOfMappedImportedUsers" :key="item.name">
                  <td>{{ item.PhoneNumber }}</td>
                  <td>
                    {{
                      item.VehicleNumbers && item.VehicleNumbers.length
                        ? item.VehicleNumbers
                        : '-'
                    }}
                  </td>
                  <td>{{ item.Name }}</td>
                  <td>{{ item.Email }}</td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="postUsers()">
            {{ $vuetify.lang.t('$vuetify.SAVE') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-dialog>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import formatDate from '@/mixins/formatDate'
import Whitelist from '@/models/whitelist'
import WhitelistUser from '@/models/whitelist-user'

export default {
  name: 'WhitelistUsersDialog',
  components: {
    EditWhitelistUserDialog: () =>
      import(
        /* webpackChunkName: "EditWhitelistUserDialog" */ '@/components/whitelists/EditWhitelistUserDialog'
      )
  },
  mixins: [formatDate],
  props: {
    visible: {
      type: Boolean,
      required: true,
      default: false
    },
    title: {
      type: String,
      required: false,
      default: ''
    }
  },
  data() {
    return {
      editWhitelistUserDialog: false,
      selectedUser: null,
      userImportConfirmDialog: false,
      arrayOfMappedImportedUsers: []
    }
  },
  computed: {
    ...mapGetters('app', ['loading']),
    ...mapGetters('whitelists', ['whitelist']),
    show: {
      get() {
        return this.visible
      },
      set(value) {
        if (!value) {
          this.$store.commit('whitelists/setCurrentWhitelistId', null)
          this.$store.commit(
            'whitelists/setWhitelist',
            new Whitelist().getObject()
          )
          this.$emit('close')
        }
      }
    }
  },
  methods: {
    ...mapActions('whitelists', ['updateAndSaveWhitelistUserStatus']),
    openEditWhitelistUserDialog(user) {
      if (user) {
        this.selectedUser = user
      } else {
        this.selectedUser = new WhitelistUser().getObject()
      }
      this.editWhitelistUserDialog = true
    },
    registrationTypeText(registrationType) {
      switch (registrationType.RegistrationType) {
        case 'MANUALLY_ADDED':
          return 'Manual'
        case 'LINK_REGISTRATION':
          return 'Public Link'
        case 'CAMPAIGN_CODE':
          return 'Campaign Code'
        case 'ONE_TIME_PROMO_CODE':
          return 'One-time promo code'
        default:
          return 'Other'
      }
    },
    deleteUser(user) {
      this.$confirm(this.$vuetify.lang.t('$vuetify.CAN_NOT_BE_UNDONE'), {
        title: this.$vuetify.lang.t('$vuetify.ARE_YOU_SURE'),
        color: 'error',
        icon: 'mdi-alert',
        persistent: true,
        buttonTrueText: this.$vuetify.lang.t('$vuetify.YES'),
        buttonFalseText: this.$vuetify.lang.t('$vuetify.CANCEL')
      }).then(option => {
        if (option === true) {
          this.$store.dispatch('whitelists/deleteWhitelistUser', user)
        }
      })
    },
    onFileSelect(files) {
      this.userImportConfirmDialog = true
      if (this.arrayOfMappedImportedUsers.length) {
        this.arrayOfMappedImportedUsers = []
      }
      files.body.forEach(user => {
        this.arrayOfMappedImportedUsers.push({
          Name: user.Name,
          Email: user.Email,
          PhoneNumber: user['Phone number'],
          VehicleNumbers: user['Car number'],
          RegistrationType: 'MANUALLY_ADDED'
        })
      })
    },
    convertIncomingWhitelistUser(whitelistUser) {
      if (!whitelistUser.ValidFrom) {
        whitelistUser.ValidFrom = new Date('0001-01-01T00:00:00Z')
      }
      if (!whitelistUser.ValidTo) {
        whitelistUser.ValidTo = new Date('0001-01-01T00:00:00Z')
      }

      whitelistUser.Vehicles = []
      if (whitelistUser.VehicleNumbers) {
        const vehicleNumbers = whitelistUser.VehicleNumbers.split(';')
        for (let i = 0; i < vehicleNumbers.length; i += 1) {
          if (vehicleNumbers[i] && vehicleNumbers[i].length > 0) {
            whitelistUser.Vehicles.push({ PlateNumber: vehicleNumbers[i] })
          }
        }
      }

      return whitelistUser
    },
    postUsers() {
      const users = []
      this.arrayOfMappedImportedUsers.forEach(element => {
        users.push(this.convertIncomingWhitelistUser(element))
      })
      this.$store.dispatch('whitelists/postWhitelistUsers', users)
      this.userImportConfirmDialog = false
    },
    downloadTemplateFile() {
      const a = document.createElement('a')
      a.href = 'https://admin.barking.ee/static/users_import_template.xlsx'
      a.setAttribute('download', 'users_import_template.xlsx')
      a.click()
    },
    updateUserStatus(whitelistuser, status) {
      this.updateAndSaveWhitelistUserStatus({
        whitelistUserId: whitelistuser.ID,
        status
      })
    }
  }
}
</script>

<style scoped>
::v-deep .vue-xlsx-container .xlsx-button {
  background-color: transparent;
  border: none;
}
</style>
